import ContentLoader, { IContentLoaderProps } from 'react-content-loader';
import { variants } from './variants';

// Map your variants to pixel heights (adjust these values to match your CSS)
const variantHeights: Record<keyof typeof variants, number> = {
  '2xl': 110,
  xl: 81,
  lg: 60,
  md: 51,
  sm: 38,
  xs: 31,
  '2xs': 22,
  '3xs': 19,
  none: 25,
};

interface HeadingLoaderProps extends Omit<IContentLoaderProps, 'uniqueKey' | 'height' | 'width'> {
  variant?: keyof typeof variants;
  width?: number | string;
  className?: string;
  uniqueKey: string;
}

export const HeadingLoader = ({
  variant = 'md',
  width = '100%',
  className = '',
  uniqueKey,
  ...rest
}: HeadingLoaderProps) => {
  const height = variantHeights[variant];

  return (
    <ContentLoader
      width={width}
      height={height}
      className={className}
      style={{ width, height }}
      uniqueKey={uniqueKey}
      {...rest}
    >
      <rect x="0" y="0" rx={5} ry={5} width="100%" height={height} />
    </ContentLoader>
  );
};
